import React from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import { Constants } from '@pwc/pwc-deals-web-common';
import featureFlags from 'common/helpers/featureFlags';
import EnableForProjectState from '../security/EnableForProjectState';
import CreateHypothesisWithSections from './CreateHypothesis/CreateHypothesisWithSections';
import AutoCreateKeyFocusArea from './CreateHypothesis/AutoCreateKeyFocusArea.tsx';
import EditHypothesisWithSections from './EditHypothesis/EditHypothesisWithSections';
import ViewHypothesis from './ViewHypothesis/ViewHypothesis';
import HypothesesListContainer from './HypothesesListContainer';
import ProjectPermissionRoute from '../security/ProjectPermissionRoute';
import authorizationService from '../../common/services/security/authorizationService';
import ReportPreview from '../../common/components/ReportPreview/ReportPreview';

const projectKFAPath = '/projects/:projectId/key-focus-areas';
const createHypothesisPath = `${projectKFAPath}/create`;
const editHypothesisPath = `${projectKFAPath}/:hypothesisId/edit`;
const reportPreviewPath = `${projectKFAPath}/:entityId/report-preview/:entityType(KFA)/:version(latest|shared)`;

const HypothesesContentRouter = () => {
  const { projectId } = useParams();
  const isAuthorized = (isProjectDisabled) => () =>
    !isProjectDisabled && authorizationService.hasValidToken();

  return (
    <EnableForProjectState projectId={projectId}>
      {({ isProjectDisabled }) => (
        <Switch>
          <Route
            exact
            path="/projects/:projectId/key-focus-areas"
            component={HypothesesListContainer}
          />
          <Route
            exact
            path="/projects/:projectId/key-focus-areas/:hypothesisId/view"
            component={ViewHypothesis}
          />
          <ProjectPermissionRoute
            exact
            permissions={[Constants.USER_PERMISSIONS.CONTRIBUTE]}
            isAuthorized={isAuthorized(isProjectDisabled)}
            path={createHypothesisPath}
            component={
              featureFlags.isAutoSaveEnabled
                ? AutoCreateKeyFocusArea
                : CreateHypothesisWithSections
            }
            fallbackRoute={
              isProjectDisabled
                ? projectKFAPath.replace(':projectId', projectId)
                : '/'
            }
            forceRefresh={featureFlags.isAutoSaveEnabled}
          />
          <ProjectPermissionRoute
            exact
            permissions={[Constants.USER_PERMISSIONS.CONTRIBUTE]}
            isAuthorized={isAuthorized(isProjectDisabled)}
            path={editHypothesisPath}
            component={EditHypothesisWithSections}
            fallbackRoute={
              isProjectDisabled
                ? projectKFAPath.replace(':projectId', projectId)
                : '/'
            }
          />
          <ProjectPermissionRoute
            exact
            permissions={[Constants.USER_PERMISSIONS.CONTRIBUTE]}
            isAuthorized={isAuthorized(isProjectDisabled)}
            path={reportPreviewPath}
            component={ReportPreview}
            fallbackRoute={
              isProjectDisabled
                ? projectKFAPath.replace(':projectId', projectId)
                : '/'
            }
          />
        </Switch>
      )}
    </EnableForProjectState>
  );
};

export default HypothesesContentRouter;
